import { apiClient } from './apiClient'

/**
 * Fetches UI labels (header, footer) for a language from the API.
 * When admin has set custom translations, they override i18n on the website.
 */
export async function fetchUiLabelsForLanguage(lang: string): Promise<Record<string, string>> {
  if (!lang) return {}
  try {
    const { data } = await apiClient.get<Record<string, string>>('/ui-labels', {
      params: { lang },
    })
    return typeof data === 'object' && data !== null ? data : {}
  } catch {
    return {}
  }
}
